// extracted by mini-css-extract-plugin
module.exports = {"header":"YqA7J6","categoryPage":"krgA5p","title":"ptBG4I","cancel":"uIETfi"};